import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomeView",
    component: HomeView,
    meta: { title: "Home" },
  },
  {
    path: "/book-now",
    name: "BookNow",
    props: true,
    component: () =>
      import(/* webpackChunkName: "booknow" */ "../views/BookNow.vue"),
  },
  // 1. Fixed Duplicate Name: Default /book-online goes to BookNow view
  {
    path: "/book-online",
    name: "BookOnlineDefault",
    props: true,
    component: () =>
      import(/* webpackChunkName: "booknow" */ "../views/BookNow.vue"),
  },
  // 2. Fixed Duplicate Name: Location specific view
  {
    path: "/book-online/:location",
    name: "BookOnline", // Kept this as the main 'BookOnline'
    props: true,
    component: () =>
      import(/* webpackChunkName: "bookonline" */ "../views/BookOnline.vue"),
  },
  // 3. Fixed Duplicate Name: Space details view
  // {
  //   path: "/book-online/:location",
  //   name: "BookOnline",
  //   props: true,
  //   component: () =>
  //     import(/* webpackChunkName: "bookonline" */ "../views/BookOnline.vue"),
  // },
  {
    path: "/booking-details/:location/:planid/:slotid",
    name: "BookingDetails",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "bookingdetails" */ "../views/BookingDetails.vue"
      ),
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicyView",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "privacypolicy" */ "../views/PrivacyPolicyView.vue"
      ),
  },
  {
    path: "/refund-policy",
    name: "RefundPolicyView",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "refundpolicy" */ "../views/RefundPolicyView.vue"
      ),
  },
  {
    path: "/terms-and-conditions",
    name: "TermsAndConditionsView",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "termsandconditions" */ "../views/TermsAndConditionsView.vue"
      ),
  },
  // Booking Status (Success/Failure)
  {
    path: "/booking/:id",
    name: "BookingStatus",
    props: true,
    component: () =>
      import(/* webpackChunkName: "booking" */ "../views/BookingView.vue"),
  },
  // Alias for Payment Gateway callbacks if needed
  {
    path: "/bookingresponse/:id",
    name: "BookingResponse",
    props: true,
    component: () =>
      import(/* webpackChunkName: "booking" */ "../views/BookingView.vue"),
  },
  {
    path: "/space-details/:location/:space",
    name: "SpaceDetails",
    component: () =>
      import(/* webpackChunkName: "booknow" */ "../views/SpaceDetails.vue"), // Redirects to BookNow as fallback
  },
  // Friendly location URLs like `/rr-nagar` should load the BookOnline view
  {
    path: "/:location",
    name: "BookOnlineAlias",
    props: true,
    component: () =>
      import(/* webpackChunkName: "bookonline" */ "../views/BookOnline.vue"),
  },
  // 404 / Catch-all
  {
    path: "*",
    name: "PageNotFound",
    component: () =>
      import(/* webpackChunkName: "booknow" */ "../views/BookNow.vue"), // Redirects to BookNow as fallback
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  base: "/",

  // Nifty Feature: Handles scrolling automatically
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
        offset: { x: 0, y: 80 }, // Offset for sticky header
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Optional: Dynamic Title Changer
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
    ? `Happy Harbour | ${to.meta.title}`
    : "Happy Harbour";
  next();
});

export default router;
